import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  TextField,
  Typography,
  Box,
} from '@material-ui/core';
import { useStoreActions } from 'easy-peasy';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { stringConstants } from '../../../constants/stringConstants';
import styles from '../dialogmodal.module.scss';

// Validation Schema for formik
const validationSchema = Yup.object().shape({
  name: Yup.string().required(stringConstants.requiredValidationMsg).matches(/^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i, "A valid domain name required e.g. example.com"),
});

const DomainModal = (props) => {
  const { open, onCancel, onSave, opts } = props;
  const { title, original, changeIndex } = opts;
  const settingsAction = useStoreActions((actions) => actions.settings);

  const commonAction = useStoreActions((action) => action.common);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const arr = [...original];

      let foundIndex = arr.findIndex(el => (el.domain.toLowerCase() === values.name.toLowerCase()));

      if (foundIndex && arr[foundIndex] && arr[foundIndex].active!==false) {
        setSubmitting(false);

        //Show the toast message
        commonAction.setSubmitSnackbar({
          status: true,
          error: true,
          messages: "Domain already exists!"
        });
      }
      else {
        //Editing mode if change index is provided else add mode
        if (changeIndex !== null && arr[changeIndex]) {
          //Replace existing value with new value
          arr[changeIndex] = {
            domain: values.name,
            isDefault: arr[changeIndex].isDefault,
            active: true
          };
        }
        else if (foundIndex !== -1) {
          arr[foundIndex] = {
            domain: values.name,
            isDefault: arr[foundIndex].isDefault,
            active: true
          };
        }
        else {
          arr.push({
            domain: values.name,
            isDefault: false,
            active: true,
          });
        }

        await settingsAction.updateAllowedDomains({
          allowed_domains: arr,
        });

        setSubmitting(false);

        //Show the toast message
        commonAction.setSubmitSnackbar({
          status: true,
          messages:
            changeIndex !== null
              ? stringConstants.updateMsg
              : stringConstants.addedRecordMsg,
        });

        onSave(arr);
        
      }
      
    } catch (err) {
      
      /*
      if (err.error ) {
        commonAction.setSubmitSnackbar({
          status: true,
          error: true,
          messages: err.error
        });
      }
      */
    
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth={'sm'}
      aria-labelledby="confirmation-dialog-title"
      PaperProps={{
        style: { borderRadius: 20 }
      }}
      open={open}
    >
      <Box className={styles.dialogmainwrapper}>
        <Formik
          initialValues={{
            name: changeIndex !== null ? original[changeIndex].domain : '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, handleChange, isValid, touched, handleBlur }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={2} className={`addNewForm`}>
                  <Grid item md={12} xs={12}>
                    <Typography variant="h6" component="h6">{title}</Typography>
                  </Grid>
                  <Grid item md={12}>
                    <TextField
                      fullWidth
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.name}
                      helperText={errors.name}
                      label="Name"
                      placeholder="Domain"
                      variant="outlined"
                    ></TextField>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  className={styles.btns}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={onCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={!isValid || values.name === ''}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default DomainModal;